import { createSelector } from 'reselect'

const getPlayList = (state) => state.playList
const getGlobal = (state) => state.global

export const getPlaylistData = createSelector(
  [getPlayList, getGlobal],
  (playList, global) => ({
    sort: playList.sort,
    loading: playList.loading,
    error: playList.error,
    requestedPage: playList.requestedPage || 1,
    listRevision: playList.listRevision || 0,
    playlists: playList.playLists,
    searchToken: playList.searchToken,
    totalItemsCount: playList.totalItemsCount,
    isIpadView: global.isIpadView,
    page: playList.page
  })
)
